import { API_BASE_URL } from '../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../lib/tenantHeaders';

const JSON_HEADERS = withTenant({ 'Content-Type': 'application/json' });

export const fetchTenants = async ({ limit = 10, offset = 1, query = {} } = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/tenants/filter`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ limit, offset, query }),
  });
  return res.json();
};

export const createTenant = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/tenants`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateTenant = async (id, data) => {
  const res = await apiFetch(`${API_BASE_URL}/tenants/${id}`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteTenant = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/tenants/${id}`, { method: 'DELETE', headers: withTenant() });
  return res.json();
};

export const testTenantConnection = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/tenants/${id}/test-connection`, {
    method: 'POST',
    headers: JSON_HEADERS,
  });
  return res.json();
};
